var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"dwp--fade"}},[(_vm.open)?_c('i-frame',{attrs:{"id":"dwp--wrapper"}},[_c('UpdateMessage')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }